import { render, staticRenderFns } from "./KeyColor.vue?vue&type=template&id=918b3b80&scoped=true&"
import script from "./KeyColor.vue?vue&type=script&lang=js&"
export * from "./KeyColor.vue?vue&type=script&lang=js&"
import style0 from "./KeyColor.vue?vue&type=style&index=0&id=918b3b80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918b3b80",
  null
  
)

export default component.exports